import React, { useState } from 'react';
import { Box, Button, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { createCheckoutSession } from '@services/payment';
import { buildBillingAddonPurchaseSuccessUrl } from '@utils/billingAddonUrls';
import { getCurrentUserId } from '@utils/userUtils';

export default function TierReview({ addonId, tierId }: { addonId: string; tierId: string }) {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const confirm = async () => {
    setLoading(true);
    setError('');
    try {
      const here = `${window.location.origin}/dashboard/billing?tab=addons&addon=${encodeURIComponent(addonId)}`;
      const result = await createCheckoutSession({
        pricing_tier_id: Number(tierId),
        metadata: {
          user_id: getCurrentUserId(),
          is_addon: true,
        },
        success_url: buildBillingAddonPurchaseSuccessUrl(addonId),
        cancel_url: `${here}&step=2&tier=${encodeURIComponent(tierId)}`,
      });
      if (!result.result?.checkout_url) throw new Error('Checkout URL was not returned');
      window.location.assign(result.result.checkout_url);
    } catch (reason) {
      setError(reason instanceof Error ? reason.message : 'Unable to start checkout');
      setLoading(false);
    }
  };
  return (
    <Box sx={{ display: 'grid', gap: 2 }}>
      <Typography variant="h6">Review &amp; pay</Typography>
      <Typography variant="body2" color="text.secondary">Step 2 of 3 · Review</Typography>
      <Typography>Selected add-on tier: <strong>{tierId}</strong></Typography>
      <Typography>Payment will be processed securely by Stripe.</Typography>
      <Typography variant="body2" color="text.secondary">
        Add-on capacity is company-wide. Facility selection is not required.
      </Typography>
      {error ? <Typography color="error">{error}</Typography> : null}
      <Box sx={{ display: 'flex', gap: 1 }}>
        <Button onClick={() => navigate(`/dashboard/billing?tab=addons&addon=${addonId}&step=1`)}>Back</Button>
        <Button
          variant="contained"
          onClick={confirm}
          disabled={loading}
        >
          {loading ? 'Starting…' : 'Confirm & pay'}
        </Button>
      </Box>
    </Box>
  );
}
